/**
 *  Default language file
 *
 *  Deze file wordt gebruikt om tekst te vertalen.
 *  Per regel wordt een stukje van de tekst vertaald.
 *  Alles voor de ':' NIET veranderen, hier wordt de tekst mee vertaald.
 *
 *  Voor elke taal een nieuw bestand maken met de landcode als naam (en.js, nl.js, fr.js en de.js)
 */
import en from 'vuetify/lib/locale/en'

export default {
  ...en,

  // Algemeen
  lang: {
    'English': 'English',
    'Dutch': 'Dutch',
    'German': 'German',
    'Français': 'Français',
    'english': 'English',
    'dutch': 'Dutch',
    'german': 'German',
    'french': 'French'
  },

  userInfo: {
    noVendor: 'No vendor assigned'
  },

  noDataText: '',

  general: {
    name: 'Name',
    user: 'Consumer Name',
    createdAt: 'Created at',
    createdBy: 'Created by',
    lastSeen: 'Last seen',
    actions: 'Actions',
    imei: 'Imei',
    frameNumber: 'Frame number',
    odo: 'Odo',
    tags: 'Tags',
    active: 'Target group',
    maintenance_plan: 'Maintenance plan',
    subscription: 'Subscription',
    business: 'Business',
    title: 'Title',
    iccid: 'ICCID',
    description: 'Description',
    firmware: 'Firmware',
    crc: 'CRC',
    entity: 'Entity',
    type: 'Type',
    color: 'Color',
    brand: 'Brand',
    model: 'Model',
    engine_brand: 'Engine brand',
    engine_model: 'Engine model',
    first_name: 'First Name',
    last_name: 'Last Name',
    address: 'Address',
    postcode: 'Zip code',
    city: 'City',
    phone: 'Phone',
    email: 'Email',
    additionalInfo: 'Additional info',
    search: 'Search',
    total: 'Total',
    sub_vendor: {
      name: 'Vendor'
    },
    role: {
      name: 'Role'
    },
    types: {
      eBike: 'e-bike',
      eCargoBike: 'cargo bike',
      speedPedelec: 'speed pedelec',
      eMoped: 'e-moped',
      unregistered: 'UNREGISTERED',
      moped: 'moped',
      automobile: 'automobile',
      other: 'other'
    },
    last_seen_at: 'Last seen',
    save: 'save',
    cancel: 'Cancel',
    close: 'close',
    searched: 'No matching results found',
    camera: {
      errorPermission: 'You need to grant camera access permisson',
      errorNoCamera: 'No camera on this device',
      errorNoHTTPS: 'Secure context required (HTTPS, localhost)',
      errorAlreadyInUse: 'Is the camera already in use?',
      errorNotSuitable: 'Installed cameras are not suitable',
      errorNotSupported: 'Stream API is not supported in this browser'
    },
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December'
    },
    serverError: 'Server error'
  },

  dataFooter: {
    itemsPerPageText: 'Items per page:',
    itemsPerPageAll: 'All',
    nextPage: 'Next page',
    prevPage: 'Previous page',
    firstPage: 'First page',
    lastPage: 'Last page',
    pageText: '{0}-{1} of {2}'
  },

  messages: {
    created: 'created',
    Created: 'Created',
    deleted: 'deleted',
    Deleted: 'Deleted',
    updated: 'updated',
    Updated: 'Updated',
    confirmTitle: 'Are your sure?',
    confirmText: 'You\'re about to delete {0}. Are you sure you want to continue?',
    confirmTextHardDelete: 'You are about to HARD DELETE {0}! Are you sure you want to continue?',
    confirmTextRestore: 'Restore {0}?',
    cancelButtonText: 'Cancel',
    confirmButtonText: 'Yes, {0}',
    confirmDelete: 'delete',
    confirmResolveText: 'You\'re about to resolve {0}. Are you sure you want to continue?',
    confirmResolve: 'resolve this case',
    confirmCloseText: 'You\'re about to close {0}. Are you sure you want to continue?',
    confirmClose: 'close this case',
    errorTitle: 'Oops!',
    errorMessage: 'Something went wrong with the request. {0}. Please contact Tracefy for support.',
    successTitle: 'Yay!',
    successMessage: '{0} was {1} successfully!'
  },

  Navigation: {
    home: 'Home',
    map: 'Map',
    information: 'Information',
    installDevices: 'Install Devices',
    analytics: 'Analytics',
    tags: 'Tags',
    reports: 'Reports',
    businesses: 'Businesses',
    entities: 'Entities',
    users: 'Users',
    devices: 'Devices',
    tokenManagement: 'Tokens',
    subscriptions: 'Subscriptions',
    subscriptionManagement: 'Subscription Management',
    maintenancePlans: 'Maintenance Plans',
    notifications: 'App Notifications',
    missing: 'Missing',
    shop: 'Shop',
    maintenanceBanner: 'Scheduled maintenance from',
    endYearNotice: 'Would you like to take advantage of the end-of-year offer?',
    clickHere: 'Click here!',
    until: 'until'
  },

  Dashboard: {
    user: 'Welcome {0}',
    map: 'Map',
    installDevices: 'Install Devices',
    analytics: 'Analytics',
    tags: 'Tags',
    reports: 'Reports',
    businesses: 'Businesses',
    entities: 'Entities',
    users: 'Users',
    devices: 'Devices',
    tokenManagement: 'API Tokens',
    subscriptions: 'Subscriptions',
    subscriptionManagement: 'Subscription Management',
    maintenancePlans: 'Maintenance Plans',
    notifications: 'App Notifications',
    information: 'Information',
    version: 'Version',
    missing: 'Missing',
    shop: 'Shop',
    notice: {
      velofollies: 'Will we meet you on January 20,21,22 at'
    }
  },

  Map: {
    tools: {
      search: 'Search something',
      noData: 'No entities found..',
      noResults: 'Please adjust your search!',
      showFleet: 'Show fleet'
    },
    sidebar: {
      reload: 'Reload',
      loadMore: 'Load more',
      trips: {
        title: 'Trips',
        dayTotals: 'Total this day: '
      },
      error: {
        noTrips: 'You do not have any trips at this moment.',
        noMarkers: 'An error occurred while loading your trips.'
      },
      information: {
        title: 'Information',
        lastLocation: 'Last location',
        noLastLocation: 'No last location',
        lastActivity: 'Last activity',
        noLastActivity: 'No activity yet',
        odoDistance: 'ODO Distance',
        brand: 'Brand',
        noBrand: 'No brand specified',
        model: 'Model',
        noModel: 'No model specified',
        powerUnit: 'Power unit',
        noPowerUnit: 'No power unit specified',
        vehicleType: 'Vehicle type',
        noVehicleType: 'No vehicle type specified',
        imei: 'IMEI',
        vendor: 'Vendor',
        business: 'Business',
        noVendor: 'Not linked to vendor',
        notApplicable: 'n/a'
      }
    }
  },

  InstallDevices: {
    title: 'Install devices',
    infoGuideNotice: 'This page has received an update, checkout the new addition here',
    notice: 'Location on map temporarily unavailable for consumer bicycles due to new AVG feature',
    noticeBosch1: 'NOTICE: Please check ',
    noticeBosch2: ' engines if the power port is activated using Bosch software',
    noticeConsumerInfo: '*The email address and telephone number are for administration purposes only (we do not send activation emails to customers)',
    form: {
      buttons: {
        install: 'Install',
        replace: 'Replace',
        useQRScanner: 'Use camera to scan QR',
        importPreset: 'Import preset',
        savePreset: 'Auto import preset next time',
        createNewPreset: 'Create new preset',
        managePresets: 'Create or edit preset',
        editPreset: 'Edit existing preset',
        deletePreset: 'Delete preset',
        createPreset: 'Create preset',
        nextStep: 'Next step',
        import: 'Import',
        createTags: 'Create tags',
        information: 'Guide and information',
        returnForm: "Return form"
      },
      types: {
        eBike: 'e-bike',
        eCargoBike: 'cargo bike',
        speedPedelec: 'speed pedelec',
        eMoped: 'e-moped',
        moped: 'moped',
        automobile: 'automobile',
        other: 'other'
      },
      tabs: {
        create: 'Install device',
        replace: 'Replace device'
      },
      title: {
        create: 'Create new Entity',
        replace: 'Replace Entity',
        managePreset: 'Manage your form presets'
      },
      panelHeaders: {
        target: 'User',
        device: 'Device',
        vehicleData: 'Vehicle data',
        details: 'Details'
      },
      subTitles: {
        selectPlan: 'Select maintenance plan',
        noPlansAvailable: 'No maintenance plans found',
        selectTags: 'Select tags'
      },
      radioButtons: {
        forCustomer: 'For customer',
        forCustomerTooltip: 'Customer is billable',
        forOwnUse: 'For own use',
        forOwnUseTooltip: 'You are billable'
      },
      placeholders: {
        presetName: 'Preset name',
        name: 'Entity name',
        frameNumber: 'Frame number',
        imei: 'Start typing IMEI...',
        maintenancePlans: 'Maintenance plans',
        odo: 'Odo in Kilometers',
        other: 'Other',
        brand: 'Brand',
        type: 'Vehicle type',
        powerunit: 'Power unit',
        engine: 'Engine',
        engineBrand: 'Engine brand',
        engineType: 'Engine type',
        model: 'Model',
        tagGroups: 'Tag preset (group)',
        licensePlate: 'License plate',
        color: 'Color',
        firstNameCustomer: 'First name customer',
        lastNameCustomer: 'Last name customer',
        customerEmail: 'Email customer',
        customerPhone: 'Phone number customer',
        extraTag: 'Add extra tag',
        preset: 'Select preset'
      },
      imei: {
        search: 'Search for IMEI number.',
        searching: 'Searching, please wait',
        notFound: 'No device found',
        needNumbers: 'Keep typing, we need {0} more number{1}',
        tip: 'Tip: Be fast and secure by typing the last 6 digits',
        huyserImei: 'Attention! This device is intended for a Huyser bike'
      },
      validation: {
        name: {
          required: 'Name is required',
          length: 'Name consists of at least 4 characters'
        },
        odo: {},
        device: {
          required: 'IMEI number is required'
        },
        frameNumber: {
          required: 'Frame number is required',
          length: 'Frame number consists of at least 4 characters'
        },
        licensePlate: {
          required: 'License plate is required',
          length: 'License plate consists of at least 4 characters'
        },
        customerInfoRequired: 'Customer information is required',
        customerEmail: {
          valid: 'Please enter a valid email address'
        }
      },
      messages: {
        fillAllFields: 'Fill all fields.',
        errorFromServer: 'Error from server',
        success: 'Entity created',
        typeBrandAreRequired: 'Type and Brand tags are required'
      },
      licensePlate: 'License plate',
      metrics: 'Metrics',
      device: 'Device',
      groups: 'Groups',
      tags: 'Tags',
      actions: {
        create: 'Create {0}',
        replace: 'Replace {0}',
        save: 'Save {0}',
        cancel: 'Cancel',
        search: 'Search for a device IMEI.'
      }
    },

    listTitle: 'Last 20 entities created',
    noData: 'No entities found!',
    noEntitiesTitle: 'No entities yet!',
    noEntitiesSubtitle: 'Create your first entity now.',
    tooltips: {
      delete: 'Delete'
    }
  },

  ImeiStatus: {
    tab: 'Status',
    serviceStatus: 'Service status',
    serviceStatuses: {
      connecting: 'Connecting',
      connected: 'Waiting for updates',
      error: 'Error',
      live: 'Live'
    },
    consentDialog: {
      title: 'Do you have customer consent?',
      text: 'This action requires viewing the location and and recent trips of this entity. If necessary, an email will be sent to the customer letting them know the location is being shared.',
      confirm: 'Yes I have consent',
      cancel: 'No return'
    },
    headers: {
      entityInfo: 'Entity info',
      liveUpdates: 'Live device updates'
    },
    liveUpdates: {
      connectionError: 'Couldn\'t connect to live service',
      lastUpdate: 'Last update',
      currentSpeed: 'Speed',
      heading: 'Heading',
      network: 'Network',
      GPS: 'GPS',
      externalBattery: 'Connected to bike battery',
      connectedWaitingForUpdates: 'Waiting for updates from device...',
      noPastLocations: 'Notice! This tracker has no historical location! It is probably not connected properly!',
      makeSureBikeOutside: 'Please make sure the vehicle is outside, turned on and has moved recently.',
      noUpdateNotice: 'If it does not show an update after 5 minutes, the device is probably connected incorrectly or is defective.'
    },
    map: {
      connectingToService: 'Connecting to live updates service...',
    },
    tooltips: {
      requestLocationUpdate: 'Request a location update',
      mapLocation: 'Show location on map',
      openInDebugView: 'Check device in debug page',
      lastWaypointsStrongGps: 'This device had a strong gps signal in the last 10 waypoints',
      lastWaypointsMediumGps: 'This device had a mediocre gps signal in the last 10 waypoints',
      lastWaypointsWeakGps: 'This device had no gps signal in the last 10 waypoints',
      recentlyOnline: 'This device has been online in the last 24 hours',
      notRecentlyOnline: 'This device has been offline for the last 24 hours',
      externalBatteryConnected: 'The bike battery is connected to the tracker',
      externalBatteryDisconnected: 'Check the tracker connection',
      strongGps: 'Strong gps signal',
      mediumGps: 'Medium gps signal',
      weakGps: 'Weak gps signal',
      networkConnected: 'Network connected',
      networkDisconnected: 'No update for more then 3 minutes'
    },
    noTripsToday: 'No trips from today found.'
  },

  Reports: {
    title: 'Reports',
    periodic: {
      title: 'Periodic overview',
      target: 'Target group',
      request: 'Request report by mail (CSV)',
      requestDone: 'Report successfully submitted. You will receive by email as soon as possible.',
      requestFail: 'An error occured while requesting your report. Please try again.',
      error: 'This target group has too many entities. Please select one with less.'
    },
    multiple: {
      all: 'Multiple (All)',
      summary: 'Multiple (Summary)'
    },
    individual: 'Individual overview',
    period: 'Period',
    date: 'Date',
    toolbar: {
      selectEntity: 'Select an entity',
      selectUser: 'Select a user',
      selectDates: 'Select dates'
    },
    notice: {
      title: 'Missing trips?',
      tooltip: 'During the selected period we experienced some potential issues'
    },

    table: {
      headers: {
        startTime: 'Start time',
        startAddress: 'Start address',
        stopTime: 'Stop time',
        stopAddress: 'Stop address',
        distance: 'Distance',
        duration: 'Duration',
        averageSpeed: 'Average speed',
        idle: 'Time on location',
        id: 'ID',
        vendor: 'Vendor',
        odo: 'Odo',
        lastSeen: 'Last seen',
        tags: 'Tags',
        name: 'Name'
      },
      actions: {
        receiveThroughEmail: 'Receive report by email'
      },
      noDataText: {
        all: 'Please specify your date range and select an entity to continue.',
        date: 'Please specify your date range to continue.',
        user: 'Please select a user.',
        searched: 'No results found... too large date ranges will not show. In that case click the button above to request via email.',
        clickSearch: 'Click search to continue.'
      }
    }
  },

  Analytics: {
    title: 'Analytics',
    chart: {
      from: 'From',
      till: 'Till',
      total: 'Total vehicles',
      noData: {
        title: 'No data available',
        body: 'There is no data for the supplied parameters.'
      },
      loading: 'Please wait while we load the data...',
      error: 'Error while loading your data'
    },
    toolbar: {
      addChart: 'Add Chart',
      addChartTip: 'Generate a chart with the + button on the right to show a chart here.'
    },
    tooltips: {
      addChart: 'Add new chart'
    },
    ranges: {
      pastWeek: 'Past week',
      pastMonth: 'Past month',
      custom: 'custom'
    },
    dialog: {
      title: 'Add new chart',
      fields: {
        preset: 'Pick a preset',
        targetGroup: 'Target group (optional)',
        period: 'Selected period'
      },
      actions: {
        create: 'Add chart',
        save: 'Save',
        cancel: 'Cancel'
      }
    }
  },

  Businesses: {
    tooltips: {
      edit: 'Edit {0}',
      delete: 'Delete {0}'
    },
    statistics: {
      availableDevices: 'Available devices:',
      totalSubscriptions: 'Total subscriptions:'
    },
    toolbar: {
      search: 'Search businesses',
      noVendor: 'Select a vendor',
      options: 'More options',
      createBusiness: 'Create business',
      editBusiness: 'Edit {0}',
      deleteBusiness: 'Delete {0}',
      createUser: 'Create user',
      linkToBusiness: 'Link entities to business'
    },
    treeView: {
      noVendors: 'No vendors found'
    },
    form: {
      name: 'Name',
      address: 'Address',
      postcode: 'Postcode',
      city: 'City',
      country: 'Country',
      email: 'Email',
      phone: 'Phone',
      businessPropertiesTitle: 'Super admin specific business properties:',
      parentBusiness: 'Parent business',
      createRootBusiness: 'Create root business',
      nameUpper: 'Name and frame number capitalized',
      hasCustomers: 'Has customers (dealer)',
      canInstallDevices: 'Can install devices',
      recoveryContract: 'Recovery contract'
    },
    dialog: {
      linkEntitiesToUser: 'Link entities to a user',
      deleteBusiness: 'Delete business',
      createUserForVendor: 'Create user for vendor',
      createBusiness: 'Create business',
      editBusiness: 'Edit business',
      linkToBusiness: 'Link entities to business',
      selectBusiness: 'Select business',
      delete: {
        deleteUser: 'Delete user',
        areYouSure: 'Are you sure you want to delete this user?',
        userDeleted: 'User successfully deleted.',
        error: 'Something went wrong while deleting this user. Please try again.'
      },
      update: {
        success: 'User successfully updated',
        error: 'Something went wrong while updated this user. Please try again'
      },

      fields: {
        firstName: 'First Name',
        lastName: 'Last Name',
        address: 'Address',
        postcode: 'Postcode',
        city: 'City',
        phone: 'Phone',
        email: 'Email',
        role: 'User Role',
        vendor: 'Vendor',
        password: 'Temporary password',
      }
    },
    devicesTab: {
      title: 'Devices',
      search: 'Search devices',
      subtitle: 'Devices for {0}',
      headers: {
        name: 'Name',
        imei: 'IMEI',
        entityName: 'Entity Name',
        business: 'Business',
        lastSeen: 'Last seen',
        createdAt: 'Created at',
        location: 'Location'
      }
    },
    entitiesTab: {
      title: 'Entities',
      search: 'Search entities',
      subtitle: 'Entities for {0}',
      headers: {
        name: 'Name',
        frameNumber: 'Frame number',
        deviceImei: 'Device IMEI',
        business: 'Business',
        userName: 'Consumer name',
        lastSeen: 'Last seen',
        createdAt: 'Created At',
        subscription: 'Subscription',
        linkTo: 'Actions'
      }
    },
    usersTab: {
      title: 'Users',
      search: 'Search users',
      subtitle: 'Users for {0}',
      headers: {
        name: 'Name',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        role: 'Role',
        business: 'Business',
        lastSeen: 'Last seen',
        createdAt: 'Created At',
        updatedAt: 'Updated At',
        actions: 'Actions'
      }
    },

    dialogs: {
      actions: {
        create: 'Create {0}',
        save: 'Save {0}',
        cancel: 'Cancel'
      },
      linkUser: {
        title: 'Link entities to a user',
        fields: {
          select: 'Select user'
        }
      },
      linkVendor: {
        title: 'Link items to a vendor',
        fields: {
          select: 'Select vendor'
        }
      },
      createUser: {
        title: 'Create user for vendor',
        fields: {
          firstName: 'First Name',
          lastName: 'Last Name',
          address: 'Address',
          postcode: 'Postcode',
          city: 'City',
          phone: 'Phone',
          email: 'Email',
          userRole: 'User Role',
          vendor: 'Vendor',
          password: 'Temporary password',
          passwordHint: 'Double click on the field for a new random password'
        }
      }
    }
  },

  UserManagement: {
    model: {
      titleCase: {
        single: 'User',
        plural: 'Users'
      },
      lowerCase: {
        single: 'user',
        plural: 'users'
      }
    },
    tooltips: {
      edit: 'Edit {0}',
      delete: 'Delete {0}',
      tokens: 'Tokens',
      showEntities: 'Show user entities',
      goToSubscriptions: 'To {0}\'s subscription'
    },
    toolbar: {
      search: 'Search'
    },
    table: {
      buttons: {},
      headers: {
        firstName: 'First Name',
        lastName: 'Last Name',
        address: 'Address',
        postcode: 'Postcode',
        city: 'City',
        phone: 'Phone',
        telephone: 'Telephone',
        email: 'Email address',
        business: 'Business',
        role: 'Role',
        lastSeen: 'Last seen',
        actions: 'Actions'
      }
    },
    dialog: {
      title: {
        create: 'New user',
        edit: 'Edit user',
        editAccount: 'Edit account'
      },
      fields: {
        firstName: 'First Name',
        lastName: 'Last Name',
        address: 'Address',
        postcode: 'Postcode',
        city: 'City',
        phone: 'Phone',
        telephone: 'Telephone',
        email: 'Email',
        userRole: 'User Role',
        role: 'User Role',
        business: 'Business',
        password: 'Temporary password',
        passwordHint: 'Double click on the field for a new random password',
        changePassword: 'Change password',
        currentPassword: 'Current password',
        newPassword: 'New password',
        newPasswordConfirmation: 'New password confirmation'
      },
      actions: {
        create: 'Create user',
        save: 'Save user',
        cancel: 'Cancel',
        hardDelete: 'HARD delete {0}',
        restore: 'restore {0}'
      }
    }
  },

  EntityManagement: {
    model: {
      titleCase: {
        single: 'Entity',
        plural: 'Entities'
      },
      lowerCase: {
        single: 'entity',
        plural: 'entities'
      }
    },
    snackbar: {
      requiredFields: 'Name, Brand and Color are required'
    },
    stepper: {
      add: 'Add tags to entities',
      addTags: 'Select tags',
      overview: 'Overview',
      continue: 'Continue',
      save: 'Submit',
      back: 'Back',
      cancel: 'Cancel',
      confirm: 'You are about to attach the following tags to {0} {1}. Are you sure?'
    },
    missing: {
      confirm: 'You are about to report a total of {0} {1}. Are you sure?',
      report: 'Report a missing entity',
      modalTitle: 'Are you sure?',
      modalText: 'Are you sure you want to report this vehicle as missing to the recovery service?',
      uninsuredEntitiesWarning: 'The following entities have no subscription and cannot be reported missing.',
      continue: 'Do you wish to continue?',
      tryAgain: 'Please try another entity or register for a subscription.',
      reportedMissing: 'Reported missing!'
    },
    csvModal: {
      title: 'Receive table data as CSV by email?',
      text: 'Within a few minutes the CSV will be sent to your user email.'
    },
    tooltips: {
      isCustomer: 'Customer entity',
      ownEntity: 'Own entity',
      csv: 'Request table data by CSV',
      create: 'Create new entity',
      tags: 'Add tags',
      missing: 'Report missing entity',
      missingDisabled: 'Recovery service disabled, interested in this service? Please contact support',
      deleteDisabled: 'Cannot be deleted because this entity has a customer',
      showAsQr: 'Show IMEI as QR-code'
    },
    noOdo: 'n/a',
    toolbar: {
      title: {
        filtered: 'Showing {0} of {1} entities',
      },
      search: 'Search'
    },
    table: {
      buttons: {
        edit: 'Edit {0}',
        view: 'View {0}',
        delete: 'Delete {0}'
      },
      headers: {
        name: 'Entity name',
        frameNumber: 'Frame number',
        subscription: 'Subscription',
        deviceImei: 'Device IMEI',
        odo: 'ODO distance',
        vendor: 'Vendor',
        targetGroup: 'Target group',
        lastSeen: 'Last seen',
        tags: 'Tags',
        createdAt: 'Created at',
        createdBy: 'Created By',
        actions: 'Actions'
      }
    },
    dialog: {
      unregisteredEntityHelper: "To modify an unregistered entity, please delete it and create a new one using the Install Devices page.",
      title: {
        create: 'New entity',
        edit: 'Edit entity',
        details: 'Entity details',
        tags: 'Select tags'
      },
      fields: {
        name: 'Name',
        imei: 'IMEI',
        frameNumber: 'Frame number',
        deviceImei: 'Device IMEI',
        vendor: 'Vendor',
        targetGroup: 'Target group',
        odo: 'ODO',
        metrics: 'Metrics'
      },
      actions: {
        create: 'Create entity',
        save: 'Save entity',
        cancel: 'Cancel'
      }
    }
  },

  MaintenancePlans: {
    title: 'Maintenance Plans',
    general: {
      allAssignedEntites: 'All entities assigned to this plan',
      createNewTrigger: 'Create new trigger',
      selectTrigger: 'Select existing trigger',
      mustHaveTitle: 'The plan must have a title',
      mustHaveDescription: 'The plan must have a description',
      maxLength: 'The maximum length for the description is 250 characters.',
      name: 'Name',
      frameNumber: 'Frame number',
      tags: 'Tags',
      vendor: 'Vendor',
      value: 'Value',
      metric: 'Metric',
      description: 'Description',
      actions: 'Actions',
      allEntities: 'All Entities',
      searchEntities: 'Search',
      searchTriggers: 'Search triggers',
      notifications: 'Notifications',
      notDeleted: 'Not deleted',
      pfew: 'Pheew, that was close!',
      notConfirmed: 'Not confirmed',
      confirmOrDismiss: 'You have to confirm or dismiss this message to delete the item.',
      planDeleted: 'Plan Deleted',
      wasDeleted: 'The plan was successfully deleted.',
      deleteFailed: 'Delete failed',
      planNotDeleted: 'The plan was not deleted',
      getPlanFailed: 'An error occurred',
      wrongGettingPlan: 'Something went wrong getting the plan. Please contact Tracefy for support.',
      failed: 'Failed',
      failedGettingTriggers: 'Failed to get this plans triggers. Please contact Tracefy for support.',
      failedGettingPlanEntities: 'Failed to get this plans entities. Please contact Tracefy for support.',
      failedRemovePlan: 'Failed to remove entity from plan',
      wrongActivatingPlan: 'Something went wrong activating the plan',
      deletePlan: 'Delete plan',
      areYouSure: 'Are you sure you want to delete this item'
    },
    toasts: {
      planned: 'Notification planned',
      completed: 'Notification marked complete',
      open: 'Notification marked open',
      archived: 'Notification archived',
      userAssigned: 'User assigned',
      userUnassigned: 'User unassigned'
    },
    tooltips: {
      createPlan: 'Create Maintenance Plan',
      editPlan: 'Edit {0}',
      deletePlan: 'Delete {0}',
      openPlan: 'Show {0} details',
      activatePlan: 'Activate {0}',
      deactivatePlan: 'Deactivate {0}',
      assignUser: 'Assign user',
      addDate: 'Add date',
      changeDate: 'Change date',
      completeNotification: 'Complete notification',
      archiveNotification: 'Archive notification',
      showDetails: 'Show details',
      hideDetails: 'Hide details'
    },
    notification: {
      noOdo: 'Entity odo not found',
      noTrigger: 'No trigger assigned',
      noTriggerValue: 'No trigger value',
      noUser: 'No user assigned',
      noEntity: 'No entity assigned'
    },
    toolbar: {
      searchText: 'Search',
      filterText: 'Filter',
      sortByText: 'Sort by',
      plans: {
        sortOptions: {
          name: 'Name',
          createdAt: 'Created at'
        },
        filterOptions: {
          activated: 'Activated',
          deactivated: 'Deactivated'
        }
      },
      notifications: {
        sortOptions: {
          entityName: 'Entity name',
          userName: 'Assigned user name',
          tiggerName: 'Trigger name',
          createdAt: 'Created at',
          plannedAt: 'Planned date'
        },
        filterOptions: {
          open: 'Open',
          done: 'Done',
          archived: 'Archived'
        }
      }
    },
    planTabs: {
      info: {
        title: 'Information'
      },
      triggers: {
        title: 'Triggers',
        headers: {
          name: 'Name',
          value: 'Value',
          metric: 'Metric',
          actions: 'Actions'
        }
      },
      entities: {
        title: 'Entities',
        headers: {
          name: 'Name',
          tags: 'Tags',
          vendor: 'Vendor',
          actions: 'Actions'
        }
      }
    },
    save: 'Save',
    close: 'Close',
    switchLabel: 'Active',
    planDialog: {
      validationRules: {
        required: 'The plan must have a {0}',
        maxLength: 'The maximum length for the {0} is {1} characters.'
      },
      title: 'Edit Maintenance Plan',
      save: 'Save',
      close: 'Close',
      createTrigger: 'Create new trigger',
      selectTrigger: 'Select existing trigger',
      searchTextTrigger: 'Search triggers',
      searchTextEntity: 'Search entities',
      create: 'Create Maintenance Plan',
      edit: 'Edit Maintenance Plan',
      description: 'Description',
      active: 'Active',

      stepOne: {
        title: 'Plan details',
        subtitle: 'Edit the title and description',
        titleText: 'Title',
        descriptionTitle: 'Description'
      },
      stepTwo: {
        title: 'Entities',
        subtitle: 'Add or remove entities for this plan',
        allEntities: 'All entities',
        searchText: 'Search entities',
        headers: {
          name: 'Name',
          frameNumber: 'Frame Number',
          tags: 'Tags',
          vendor: 'Vendor'
        }
      },
      stepThree: {
        title: 'Triggers',
        subtitle: 'Add or remove triggers for this plan',
        searchText: 'Search triggers',
        headers: {
          name: 'Name',
          value: 'Value',
          metric: 'Metric',
          description: 'Description',
          actions: 'Actions'
        }
      }
    },
    noPlans: 'No Maintenance plans, yet!',
    noPlanSearchResult: 'No Maintenance Plans for criteria!',
    noNotifications: 'No Notifications, yet!',
    noNotificationSearchResult: 'No Notifications for criteria!'
  },

  DeviceManagement: {
    model: {
      titleCase: {
        single: 'Device',
        plural: 'Devices'
      },
      lowerCase: {
        single: 'device',
        plural: 'devices'
      }
    },
    tooltips: {
      edit: 'Edit {0}',
      delete: 'Delete {0}'
    },
    toolbar: {
      title: {
        filtered: 'Showing {0} of {1} devices',
        total: 'Total'
      },
      search: 'Search',
      selected: 'Selected: {0} devices',
      scan: 'IMEI'
    },
    table: {
      buttons: {},
      headers: {
        index: 'Index',
        title: 'Device',
        description: 'Description',
        imei: 'IMEI',
        iccid: 'ICCID',
        model: 'Model',
        firmwareVersion: 'Firmware version',
        settingsCrc: 'Settings CRC',
        entityName: 'Entity Name',
        subVendorName: 'Vendor',
        lastSeen: 'Last seen',
        createdAt: 'Created at',
        actions: 'Actions'
      }
    },
    dialog: {
      title: {
        create: 'New device',
        edit: 'Edit device',
        linkDevicesDialog: 'Link devices to enterprise',
        scanDevicesDialog: 'Scan devices'
      },
      fields: {
        title: 'Title',
        description: 'Description',
        imei: 'Imei',
        model: 'Model',
        firmwareVersion: 'Firmware version',
        settingsCrc: 'Settings CRC',
        iccid: 'ICCID',
        vendor: 'Enterprise',
        lastSeen: 'Last seen',
        createdAt: 'Created at'
      },
      actions: {
        create: 'Create device',
        save: 'Save',
        cancel: 'Cancel',
        exportAndSave: 'Export & Save'
      }
    },
    input: {
      placeholder: 'Select enterprise'
    },
    sweetAlert: {
      title: '{0} devices failed to link!'
    }
  },

  Information: {
    intro: {
      text: '',
      link: 'Are you looking for our api documentation?'
    },

    tabs: {
      installation: 'Installation guides',
      portal: 'Portal guides',
      app: 'App guides',
      marketing: 'Marketing Content'
    },
    videos: 'Videos',
    documents: 'Documents',
    images: 'Images'
  },

  Missing: {
    title: 'Missing entities',
    messages: {
      noCases: 'There are no cases (yet).',
      locating: {
        success: 'Bluetooth turned on for 10 minutes',
        failed: 'There went something wrong while activating bluetooth, please try again.'
      },
      resolved: 'Case marked as resolved successfully.',
      closed: 'Case marked as closed successfully.'
    },
    tooltips: {
      locate: 'Locate the device via bluetooth',
      close: 'Couldn\'t locate the entity? Close this case.',
      resolve: 'Entity located and recovered? Resolve this case.'
    },
    dialogs: {
      close: 'Are you sure you want to close this case?'
    }
  },

  Notifications: {
    createNotification: 'Create notification',
    editNotification: 'Edit notification',
    lastSentNotifications: 'Last sent notifications',
    confirmDeleteMessage: 'Are you sure you want to delete this planned notification?',
    scheduleNotification: 'Schedule notification',
    updateNotification: 'Update notification',
    deleteNotification: 'Delete this planned notification',
    plannedNotifications: 'Planned notifications',
    validationFailedMessage: 'Date, time, title and message are required!',
    allUsers: 'All consumers',
    recipients: 'Recipients',
    selectDate: 'Select date',
    selectTime: 'Select time',
    title: 'Title',
    body: 'Type your message here'
  },

  Shop: {
    addedToCart: 'Added to cart!'
  },

  AppBar: {
    changeLanguage: 'Change language',
    toggleNightmode: 'Toggle nightmode',
    toggleChristmas: 'Toggle christmas',
    logout: 'Logout'
  },

  Support: {
    emailUs: 'Email us',
    callOrApp: 'Call or App us',
    weekdays: 'mo-fr'
  },
  Snackbar: {
    success: 'Success!',
    generalError: 'Action failed!'
  }
}
